"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CandidateWorkHistorySchema = void 0;
const zod_1 = __importDefault(require("zod"));
const shared_1 = require("../shared");
const candidate_enum_1 = require("./candidate.enum");
exports.CandidateWorkHistorySchema = zod_1.default.object({
    id: shared_1.UUIDSchema,
    candidateId: shared_1.UUIDSchema,
    industryId: shared_1.UUIDSchema,
    occupationId: shared_1.UUIDSchema,
    companyName: zod_1.default.string(),
    jobDetail: zod_1.default.string().nullable(),
    annualSalary: zod_1.default.number().int().nullable(),
    maxSalary: zod_1.default.number().int().nullable(),
    minSalary: zod_1.default.number().int().nullable(),
    isCurrent: zod_1.default.boolean(),
    endDate: shared_1.ISODateSchema.nullable(),
    startDate: shared_1.ISODateSchema,
    employmentType: candidate_enum_1.EmploymentTypeEnum,
    createdAt: shared_1.ISODateTimeSchema,
    updatedAt: shared_1.ISODateTimeSchema,
});
